import Layout from '../components/layout/Layout';

const TermsPage = () => {
  return (
    <Layout>
      <div className="py-10">
        <div className="container-custom">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Términos y Condiciones</h1>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Última actualización: {new Date().toLocaleDateString()}
          </p>

          <div className="mt-6 space-y-6 text-gray-700 dark:text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">1. Aceptación</h2>
              <p className="mt-2 text-sm">
                Al acceder o utilizar Illustra, aceptás estos Términos y Condiciones. Si no estás de acuerdo, no uses la
                plataforma.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">2. Cuenta y seguridad</h2>
              <ul className="mt-3 space-y-2 text-sm">
                <li>- Sos responsable de la actividad que ocurra en tu cuenta.</li>
                <li>- Mantené tu contraseña y acceso al email en forma segura.</li>
                <li>- No compartas credenciales ni suplantes identidad.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">3. Contenido de usuarios</h2>
              <p className="mt-2 text-sm">
                Conservás los derechos sobre el contenido que publiques. Al publicar, otorgás a Illustra una licencia no exclusiva
                para alojar, mostrar y distribuir el contenido dentro de la plataforma, exclusivamente para operar el servicio.
              </p>
              <div className="mt-3 text-sm space-y-2">
                <p>
                  Illustra no reclama propiedad sobre tus creaciones. Tus obras, publicaciones, series y cualquier contenido que
                  subas siguen siendo tuyos, sujeto a la licencia limitada necesaria para que la plataforma funcione.
                </p>
                <p>
                  <strong>IA:</strong> Illustra no utilizará el contenido de los usuarios para entrenar modelos de inteligencia
                  artificial. Asimismo, queda prohibido que terceros extraigan contenido de Illustra para entrenamiento de IA sin
                  autorización expresa del titular de derechos y de Illustra.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">4. Uso permitido</h2>
              <ul className="mt-3 space-y-2 text-sm">
                <li>- No publiques contenido ilegal, engañoso, violento o que infrinja derechos de terceros.</li>
                <li>- No intentes acceder a sistemas o datos sin autorización.</li>
                <li>- No realices spam, scraping abusivo o acciones que degraden el servicio.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">5. Prohibiciones estrictas y cooperación con autoridades</h2>
              <div className="mt-2 text-sm space-y-3">
                <p>
                  Illustra aplica <strong>tolerancia cero</strong> ante contenido ilegal y, en especial, ante cualquier material de
                  abuso sexual infantil (CSAM) o contenido que sexualice a menores. Está <strong>absolutamente prohibido</strong>{' '}
                  subir, almacenar, compartir, solicitar o intentar distribuir este tipo de material en la plataforma.
                </p>
                <p>
                  Ante la detección, denuncia o sospecha razonable, Illustra podrá actuar de inmediato y sin previo aviso,
                  incluyendo: suspensión o cancelación definitiva de la cuenta, bloqueo de accesos, preservación de evidencia y
                  adopción de medidas técnicas para impedir la continuidad de la conducta. Illustra <strong>se reserva el derecho</strong>{' '}
                  de cooperar con autoridades competentes y de realizar reportes a organismos nacionales e internacionales conforme
                  a la ley aplicable, así como proveer la información disponible (por ejemplo, identificadores de cuenta, registros
                  técnicos y contenido relacionado) cuando sea requerido o permitido legalmente.
                </p>
                <p>
                  En la medida en que Illustra administre saldos, beneficios, pagos u otros montos asociados a la cuenta, Illustra
                  se reserva el derecho de retenerlos o inmovilizarlos y, cuando sea legalmente permitido y corresponda, destinarlos
                  a organizaciones que luchan contra este tipo de crímenes. Este apartado no limita ni reemplaza obligaciones
                  legales, órdenes judiciales o requerimientos de autoridades.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">6. Servicios y órdenes</h2>
              <p className="mt-2 text-sm">
                Illustra ofrece herramientas para que usuarios publiquen servicios y gestionen órdenes. Cada parte es responsable
                de la información que provee, del cumplimiento de acuerdos y de la comunicación en el chat. Illustra no garantiza
                resultados ni asume responsabilidad por acuerdos entre usuarios.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">7. Moderación</h2>
              <p className="mt-2 text-sm">
                Podemos revisar, restringir o eliminar contenido o cuentas que infrinjan estos términos o pongan en riesgo la
                plataforma o a otros usuarios.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">8. Limitación de responsabilidad</h2>
              <p className="mt-2 text-sm">
                La plataforma se brinda “tal cual”, sin garantías expresas o implícitas. En la máxima medida permitida por la ley,
                Illustra no será responsable por pérdidas indirectas, incidentales o consecuentes derivadas del uso del servicio.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">9. Propiedad intelectual y extracción indebida</h2>
              <div className="mt-2 text-sm space-y-3">
                <p>
                  Queda prohibido que terceros, sin autorización expresa, extraigan o recopilen información de usuarios, realicen
                  scraping, intenten reconstruir bases de datos, o copien/republíquen contenido de Illustra de forma sistemática o
                  con fines comerciales.
                </p>
                <p>
                  Illustra podrá implementar medidas técnicas para prevenir estas conductas (por ejemplo, limitación de tráfico,
                  bloqueos, restricciones de acceso) y, cuando corresponda, iniciar acciones legales y reclamar daños y perjuicios
                  contra quienes incurran en estas prácticas.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">10. Cambios</h2>
              <p className="mt-2 text-sm">
                Illustra se reserva el derecho de modificar estos Términos en cualquier momento para reflejar cambios del producto,
                ajustes de políticas o requisitos legales. Cuando corresponda, publicaremos la versión actualizada y la fecha de
                vigencia. El uso continuado de la plataforma luego de la publicación implica la aceptación de los cambios.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">11. Contacto</h2>
              <p className="mt-2 text-sm">
                Si tenés dudas sobre estos Términos, escribinos a{' '}
                <a href="mailto:illustra.contacto@gmail.com" className="text-indigo-600 dark:text-indigo-400 hover:underline">
                  illustra.contacto@gmail.com
                </a>
                .
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TermsPage;

